module.exports = __webpack_public_path__ + "img/shot_img20022503.8a31b51c.gif";